import React, { useEffect, useRef } from 'react';
import {
  checkBeforeHighAndThick,
  checkHighAndThick
} from '../../../../utils/helpers/photosGrid';
import { StyledPhoto, PhotoWrapper } from './styled';
import { Photo } from '../../../../graphql/graphql';

interface PhotosGridItemProps {
  photo: Photo;
  index: number;
  photosCount: number;
  pageNumber: number;
  isSinglePhoto?: boolean;
  onOpenGallery: (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    photoNumber?: number
  ) => void;
}

export const PhotosGridItem: React.FC<PhotosGridItemProps> = ({
  photo,
  index,
  photosCount,
  pageNumber,
  isSinglePhoto,
  onOpenGallery
}) => {
  const ref = useRef<HTMLDivElement | null>(null);

  const current = index + 1;
  const next = index + 2;
  const isHighAndThick = checkHighAndThick(photosCount, current);
  const isBeforeHighAndThick = checkBeforeHighAndThick(
    checkHighAndThick(photosCount, next),
    current
  );

  useEffect(() => {
    if (pageNumber === current && ref.current) {
      ref.current.scrollIntoView(false);
    }
  }, []);

  const handleGalleryClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    onOpenGallery(e, index + 1);
  };

  return (
    <PhotoWrapper
      data-cy="photo-wrapper"
      ref={ref}
      role="button"
      tabIndex={-1}
      onClick={handleGalleryClick}
      onKeyPress={handleGalleryClick}
      $isHighAndThick={isHighAndThick}
      $isBeforeHighAndThick={isBeforeHighAndThick}
      $isSinglePhoto={isSinglePhoto}
    >
      <StyledPhoto
        src={photo.f660x496}
        alt="thumbnail"
        $isSinglePhoto={isSinglePhoto}
      />
    </PhotoWrapper>
  );
};
